import { Controller } from "@hotwired/stimulus"
import mermaid from "mermaid"

export default class extends Controller {
  connect() {    
    this.initializeMermaid()
    
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      this.renderDiagrams()
    })
    
    // Listen for theme changes
    this.themeChangeHandler = this.handleThemeChange.bind(this)
    window.addEventListener('themeChanged', this.themeChangeHandler)
  }

  disconnect() {
    // Clean up event listener
    window.removeEventListener('themeChanged', this.themeChangeHandler)
  }

  initializeMermaid() {
    // Initialize Mermaid
    mermaid.initialize({
      startOnLoad: false,
      theme: this.getTheme(),
      securityLevel: 'loose',
      fontFamily: 'inherit',
      // Add more explicit configuration
      flowchart: {
        htmlLabels: true,
        useMaxWidth: true
      },
      // Custom theme variables for light green background
      themeVariables: this.getThemeVariables()
    })
  }

  handleThemeChange(event) {
    // Reinitialize Mermaid with new theme
    this.initializeMermaid()
    
    // Re-render all diagrams
    this.renderDiagrams()
  }

  async renderDiagrams() {
    const mermaidElements = this.element.querySelectorAll('.mermaid')
    
    for (const element of mermaidElements) {
      try {
        // Store original code if not already stored
        if (!element.dataset.originalCode) {
          element.dataset.originalCode = element.textContent.trim()
        }
        
        const code = element.dataset.originalCode
        
        if (!code) {
          console.warn('Empty mermaid code found')
          continue
        }
        
        const id = element.id || `mermaid-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
        
        // Render the mermaid diagram
        const { svg } = await mermaid.render(`${id}-svg`, code)
        element.innerHTML = svg
      } catch (error) {
        console.error('Mermaid rendering error:', error)
        const code = element.dataset.originalCode || element.textContent.trim()
        element.innerHTML = `<div class="text-red-500 p-4 border border-red-300 rounded">
          <strong>Diagram Error:</strong> ${error.message}
          <pre class="mt-2 text-sm bg-red-50 dark:bg-red-900 p-2 rounded">${this.escapeHtml(code)}</pre>
        </div>`
      }
    }
  }



  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }

  getTheme() {
    return 'dark'
  }

  getThemeVariables() {
    return {
      primaryColor: '#e5b070',
      primaryTextColor: '#ffffff',
      primaryBorderColor: '#e5b070',
      lineColor: '#f0c991',
      sectionFill: '#1a1a1a',
      background: '#111111',
      altBackground: '#262626',
      secondaryColor: '#ffffff',
      tertiaryColor: '#a1a1aa'
    }
  }
} 